import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 24,
    lineHeight: 1.2,
    color: '#5E6369',

    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },

  divider: {
    width: 40,
    height: 2,
    backgroundColor: '#77CC21',
    margin: '4px 0',
  },
}));
